import React, { useState, useEffect } from "react";

// Package imports
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  Backdrop,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";

import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form } from "formik";

//user import

import { addvalidation } from "../../../../Services/validations/AdminPortal/Ministry";
import { headersPost } from "../../../../Services/API";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";

//constants

const initialValue = {
  name: "",
  // email: "",
  population: "",
};

//component

const EditProvince = () => {
  //Hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  //states

  const [formValues, setFormValues] = useState(initialValue);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  //form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      state: {
        id: values?.id,
        name: values?.name,
        // email: values?.email,
        population: values?.population,
      },
    };
    setOpen(true);

    headersPost(MINISTRY_API_ULRS.UPDATE_PROVINCE, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-1);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //set

  useEffect(() => {
    state?.node?.id && setFormInitialValues();
  }, [state]);

  //set form initial values

  const setFormInitialValues = () => {
    setFormValues((prev) => ({ ...prev, ...state?.node }));
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render
  return (
    <Paper
      sx={{ p: 2, margin: "auto", maxWidth: 400, flexGrow: 1, borderRadius: 2 }}
    >
      <Box padding={2}>
        <Typography
          // display={"flex"}
          // justifyContent={"center"}
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Edit Province
        </Typography>
        <Formik
          initialValues={formValues}
          onSubmit={formSubmitHanlder}
          validationSchema={addvalidation}
          enableReinitialize
        >
          {({ values, touched, errors, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 2, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={250}
                >
                  {/* Name */}

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="name"
                      onChange={handleChange}
                      error={touched?.name && Boolean(errors?.name)}
                      helperText={touched?.name && errors?.name}
                      value={values.name}
                      placeholder="Name"
                      fullWidth
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                  </Grid>

                  {/* Email */}
                  {/* <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      fullWidth
                      name="email"
                      type={"email"}
                      onChange={handleChange}
                      value={values.email}
                      error={touched?.email && Boolean(errors?.email)}
                      helperText={touched?.email && errors?.email}
                      placeholder="Email"
     
                    />
                  </Grid> */}

                  {/* Domain */}
                  <Grid container>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Population"
                      name="population"
                      type={"text"}
                      onChange={handleChange}
                      value={values.population}
                      error={touched?.population && Boolean(errors?.population)}
                      helperText={touched?.population && errors?.population}
                      fullWidth
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          // borderRadius: "37px !important",
                          minWidth: "20%",
                        }}
                      >
                        Update
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default EditProvince;
